import { Injectable } from '@angular/core';
import CONFIG from '../config';
import { BackendService } from '../shared/backend.service';
import { NotificationService } from '../notification.service';
//import { NotificationService } from '../notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class ResetFormService {
  forgotPasswordShow: boolean = false;
  validEmail: boolean = false;
  emailPending: boolean = false;
  validAnswer: boolean = false;
  pwd_reset_q1: string = '';
  pwd_reset_q2: string = '';
  questions: string[] = [];
  selectedQuestion: number = 0; //index of questions array of selected question

  constructor(public _backendService: BackendService, public _notificationService: NotificationService) {}

  forgottenPasswordFormUpdate(status: boolean, $event?: any) 
  {
   // console.log(status);
      if($event) { $event.preventDefault(); };
      this.validEmail = false;
      this.validAnswer = false;
      this.forgotPasswordShow = status;
  }

  switchQuestion() {
      this.selectedQuestion = this.selectedQuestion === 0 ? 1 : 0;
  }

  submitEmail(email: string) {
      this.emailPending = true;
      this._backendService.postData(email, `${CONFIG.sendemailApiUrlBase}/checkcustomer`)
          .subscribe(response => {
           console.log(response);
              this.emailPending = false;
              if(response['result']) {
                console.log(response);
                  //if user hasn't set reset questions yet, don't allow
                  if(!response || !response) {
                      this._notificationService.showNotification({ 
                          message: 'No password reset questions are on file for your login - Please contact your site administrator to reset your password.', 
                          type: 'error' 
                      });
                      this.forgotPasswordShow = false;
                      return;
                  }
                 // console.log(response['pwd_reset_q1'],response['pwd_reset_q2']);
                  this.questions.push( response['pwd_reset_q1'],response['pwd_reset_q2']);
                  this.validEmail = true;
              } else {
                  this._notificationService.showNotification({ message: 'Invalid CustomerID', type: 'error' });
                  this.validEmail = false;
              }
          });
  }

  submitAnswer(answerObj: Object) {
      //add the text of the selected question to the object sent to the server
      answerObj['Question'] = this.questions[this.selectedQuestion];

      //console.log(answerObj['Question']);
      //console.log(this.questions[this.selectedQuestion]);

      return this._backendService.postData(answerObj, `${CONFIG.sendemailApiUrlBase}/email`)
           .map(response => {
              return response;
          })


          // .catch(this.handleError)
          // .finally(() => {
          //     this._loadingService.hide();
          // });
  }

  disableUser(email: string) {
      this._backendService.postData(email, `${CONFIG.sendemailApiUrlBase}/disableuser`)
          .subscribe(response => {
              this._notificationService.showNotification({ message: response['msg'], type: 'success' });
          }, error => {
              this._notificationService.showNotification({ message: error.msg, type: 'error' });
          });
  }
}